/*
 * @Author: Lsuihua Lsuihua_email@163.com
 * @Date: 2023-11-21 09:41:56
 * @LastEditors: Lsuihua Lsuihua_email@163.com
 * @LastEditTime: 2023-11-21 10:36:20
 * @FilePath: \internation-live-web\src\router\index.js
 * @Description:路由
 */
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/notification-live",
    children: [
      {
        path: "/notification-live",
        component: () => import("@/views/home/index"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
